<template>
  <div id="app">
    <header id="nav">
      <a-row :gutter="16">
        <a-col :xs="0" :md="3">
          <router-link to="/">Home</router-link>
        </a-col>
        <a-col :xs="0" :md="3">
          <router-link to="/service">Service</router-link>
        </a-col>
        <a-col :xs="0" :md="3">
          <router-link to="/products">Products</router-link>
        </a-col>
        <a-col :md="6" :xs="{ span: 24 }" class="logo">
          <router-link to="/">
            <img alt="Sian Plastic Protech" src="./assets/logo.png" />
          </router-link>
        </a-col>
        <a-col :xs="0" :md="3">
          <router-link to="/about">About</router-link>
        </a-col>
        <a-col :xs="0" :md="3">
          <router-link to="/newsroom">Newsroom</router-link>
        </a-col>
        <a-col :xs="0" :md="2">
          <router-link to="/contact">Contact</router-link>
        </a-col>
        <!-- <a-col :xs="0" :md="1">
          <router-link to="/search">
            <img class="search" src="./assets/icon-search.png" alt="Search" />
          </router-link>
        </a-col>-->
      </a-row>
    </header>

    <section id="content">
      <transition name="slide-fade">
        <router-view />
      </transition>
    </section>

    <Footer>
      <a-row>
        <a-col :md="{ span: 4, offset: 4 }" :xs="{ span: 18, offset: 3 }" id="ft-link">
          <h3>Company Info</h3>
          <ul>
            <li>
              <router-link to="/service">Service</router-link>
            </li>
            <li>
              <router-link to="/products">Products</router-link>
            </li>
            <li>
              <router-link to="/about">About Us</router-link>
            </li>
            <!-- <li>
              <router-link to="/about/team">Sales Team</router-link>
            </li>-->
            <li>
              <router-link to="/newsroom">Newsroom</router-link>
            </li>
            <li>
              <router-link to="/contact">Contact Us</router-link>
            </li>
          </ul>
        </a-col>

        <a-col :md="{ span: 4, offset: 0 }" :xs="{ span: 18, offset: 3 }" id="ft-category">
          <h3>Product Category</h3>
          <ul>
            <li>
              <router-link to="/category/foam_ear_plugs">Foam Ear Plugs</router-link>
            </li>
            <li>
              <router-link to="/category/silicone_ear_plugs">Silicone Ear Plugs</router-link>
            </li>
            <li>
              <router-link to="/category/filter_ear_plugs">Filter Ear Plugs</router-link>
            </li>
            <li>
              <router-link to="/category/moldable_ear_plugs">Custom Moldable Ear Plugs</router-link>
            </li>
            <li>
              <router-link to="/category/passive_noise_reduction_ear_muffs">Ear Muffs</router-link>
            </li>
            <li>
              <router-link to="/category/electronic_ear_muffs">Shooting Ear Muffs</router-link>
            </li>
          </ul>
        </a-col>

        <a-col :md="{ span: 8, offset: 3 }" :xs="{ span: 18, offset: 3 }" id="ft-social">
          <h3>Follow Us</h3>
          <p>Get Latest News and Coupons</p>

          <a href="https://www.facebook.com/sianplastic" alt="Sian Facebook">
            <a-icon type="facebook" />
          </a>
          <a
            href="https://www.linkedin.com/company/jiangyin-sian-plastic-protech-co.-ltd/"
            alt="Sian Linkedin"
          >
            <a-icon type="linkedin" />
          </a>
          <a href="skype:live:baaa1d6976abda1d?chat" alt="Sian Skype">
            <a-icon type="skype" />
          </a>
          <a href="https://sian.en.alibaba.com" alt="Sian Alibaba">
            <a-icon type="alibaba" />
          </a>
        </a-col>
      </a-row>

      <a-row id="ft-contact">
        <a-col :md="{ span: 16, offset: 4 }" :xs="{ span: 18, offset: 3 }">
          <a-row>
            <a-col :md="12">
              <a-icon type="mail" />&nbsp;
              <a href="mailto:sales6@cnsian.com">sales6@cnsian.com</a>
            </a-col>
            <a-col :md="12">
              <a-icon type="phone" />&nbsp;
              <a href="tel:+86-0510-81602599">+86-0510-81602599</a>
            </a-col>
          </a-row>

          <a-divider dashed />
        </a-col>
      </a-row>

      <a-row id="ft-copyright">
        <a-col :md="{ span: 16, offset: 4 }" :xs="{ span: 18, offset: 3 }">
          <h4>© {{ new Date().getFullYear() }} Sian Plastic Protech.</h4>
        </a-col>
      </a-row>

      <div>
        <a-back-top />
        <strong style="color: rgba(64, 64, 64, 0.6)">gray</strong>
      </div>
    </Footer>
  </div>
</template>

<style lang="scss">
@import "@/global-styles/colors.scss";
@import "@/global-styles/typography.scss";

#app {
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-family: $system-font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $vue;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

header {
  height: 80px;
  padding: 30px 12.5%;
  text-align: center;
  a {
    @include medium-text($vue);
    color: $vue;
    &:link {
      text-decoration: none;
    }
    &.router-link-exact-active {
      color: $current-link;
    }
  }
  .logo {
    img {
      max-width: 100%;
      max-height: 100%;
      position: relative;
      top: -18px;
    }
  }
  img.search {
    line-height: 21px;
  }
}

#content {
  flex: 1;
}

.slide-fade-enter-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
// .slide-fade-leave-active {
//   transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
// }
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  // transform: translateX(10px);
  opacity: 0;
}

footer {
  padding: 30px 0;
  background: $green-foot;
  color: $white;
  a {
    &:link {
      text-decoration: none;
    }
    &.router-link-exact-active {
      color: $current-link;
    }
  }
  h3 {
    color: $white;
  }
  li {
    list-style: none;
    a {
      font-size: 17px;
      color: $white;
      text-decoration: none;
    }
  }
  #ft-link,
  #ft-category {
    display: flex;
    flex-direction: column;
    justify-content: left;
    ul {
      display: flex;
      flex-direction: column;
      justify-content: left;
      padding: 0;
    }
  }
  #ft-social {
    p {
      color: $white;
    }
    a {
      margin-right: 30px;
      color: white;
      font-size: 3em;
    }
  }
  #ft-contact {
    margin-top: 30px;
    text-align: center;
    font-size: 17px;
    a {
      color: $white;
    }
  }
  #ft-copyright {
    text-align: center;
    h4 {
      color: $white;
    }
  }
}
</style>

<script>
export default {
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Sian Plastic Protech",
    // all titles will be injected into this template
    titleTemplate: "%s | Sian Plastic Protech"
  }
};
</script>
